<template>
  <page-header-wrapper>
    <template v-slot:content>
      <a-row :gutter="[16, 16]">
        <Statistics
          :col="12"
          title="用户总数"
          :total="statisticsData.userNum"
        ></Statistics>
        <Statistics
          :col="12"
          title="会员用户总数"
          :total="statisticsData.vipUserNum"
        ></Statistics>
        <Statistics
          :col="12"
          title="新增用户数"
          text-align="left"
          font-text-align="left"
          :total="addUserNum"
          isSwitch
          v-model:switchValue="userTotalSwitch"
          @change="changeChange($event, 1)"
        ></Statistics>
        <!--        <Statistics :col="12" title="累计购买存储空间收入" text-align="left" font-text-align="left" :total="vipMoney" isSwitch :switchValue.sync="userTotalSwitchthree" @change="changeChange($event,2)"></Statistics>-->
        <!--        <Statistics :col="24" title="统计一下" type="Echarts" id="lineCharts" isCustomizedEcharts :option="option"></Statistics>-->
      </a-row>
    </template>
  </page-header-wrapper>
</template>

<script>
import { PageHeaderWrapper } from '@/components/ProLayout'
import Statistics from '@/components/Statistics/Statistics'
import { homePageStatistics } from '@/api/biz/user'
export default {
  name: 'Index',
  components: {
    PageHeaderWrapper,
    Statistics,
  },
  data() {
    return {
      userTotalSwitch: 'a',
      userTotalSwitchtwo: 'a',
      userTotalSwitchthree: 'a',
      statisticsData: {
        userNum: 0,
        vipUserNum: 0,
        todayNewUsers: 0,
        todayVipMoney: 0,
        yesterdayNewUsers: 0,
        yesterdayVipMoney: 0,
        sevenNewUsers: 0,
        sevenVipMoney: 0,
      },
      addUserNum: 0,
      vipMoney: 0,
      vipTimesData: [],
      vipOrderNum: [],
      vipMoneys: [],
      option: [],
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getAllXinxi()
  },
  methods: {
    genjuXuanxiang() {
      if (this.userTotalSwitch == 'a') {
        //今日
        this.addUserNum = this.statisticsData.todayNewUsers
      } else if (this.userTotalSwitch == 'b') {
        //昨日
        this.addUserNum = this.statisticsData.yesterdayNewUsers
      } else if (this.userTotalSwitch == 'c') {
        //近七日
        this.addUserNum = this.statisticsData.sevenNewUsers
      }

      if (this.userTotalSwitchthree == 'a') {
        //今日
        this.vipMoney = this.statisticsData.todayVipMoney
      } else if (this.userTotalSwitchthree == 'b') {
        //昨日
        this.vipMoney = this.statisticsData.yesterdayVipMoney
      } else if (this.userTotalSwitchthree == 'c') {
        //近七日
        this.vipMoney = this.statisticsData.sevenVipMoney
      }
    },
    getAllXinxi() {
      homePageStatistics().then((res) => {
        console.log(res)
        this.statisticsData = {
          userNum: parseFloat(res.data.userNum),
          vipUserNum: parseFloat(res.data.vipUserNum),
          todayNewUsers: parseFloat(res.data.todayNewUsers),
          todayVipMoney: parseFloat(res.data.todayVipMoney),
          yesterdayNewUsers: parseFloat(res.data.yesterdayNewUsers),
          yesterdayVipMoney: parseFloat(res.data.yesterdayVipMoney),
          sevenNewUsers: parseFloat(res.data.sevenNewUsers),
          sevenVipMoney: parseFloat(res.data.sevenVipMoney),
        }

        this.vipTimesData = res.data.vipOrderNum.map((i) => i.times)
        this.vipOrderNum = res.data.vipOrderNum.map((i) => i.nums)
        this.vipMoneys = res.data.vipOrderMoney.map((i) => i.moneys)
        this.option = {
          title: {
            text: '存储空间收入概览',
          },
          tooltip: {
            trigger: 'item',
            triggerOn: 'mousemove',
          },
          legend: {
            data: ['存储空间订单', '存储空间收入'],
          },

          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          // toolbox: {
          //   feature: {
          //     saveAsImage: {}
          //   }
          // },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.vipTimesData,
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: '存储空间订单',
              type: 'line',
              stack: 'Total',
              data: this.vipOrderNum,
            },
            {
              name: '存储空间收入',
              type: 'line',
              stack: 'Total',
              data: this.vipMoneys,
            },
          ],
        }
        this.genjuXuanxiang()
      })
    },
    changeChange(e, num) {
      if (num == 1) {
        this.userTotalSwitch = e
      } else {
        this.userTotalSwitchthree = e
      }
      this.genjuXuanxiang()
    },
  },
}
</script>
